import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers, ReactNodeGenerator} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {McqBehaviorSelector} from './parts/McqBehaviorSelector';
import {McqEditStore} from './parts/McqEditStore';

function* renderer(store: McqEditStore): ReactNodeGenerator {
  yield (
    <div key="behavior" className="row justify-content-end">
      <div className="col-md-4 col-xs-6">
        <div className="form-group">
          <label>Behavior</label>
          <McqBehaviorSelector value={store.behavior.value}
                               onChange={store.behavior.setValue}/>
        </div>
      </div>
      <div className="col-auto">
        <button className="btn btn-primary" onClick={store.addChoice}>Add choice</button>
      </div>
    </div>
  );

  const choices = store.choices;
  const behavior = store.behavior.value;

  for (let index = 0; index < choices.length; index++) {
    let choice = store.choices[index];
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className="form-group">
            <input type="text" className="form-control"
                   value={choice.label.value}
                   onChange={choice.label.onChangeHandler}/>
          </div>
        </div>
        <div className="col-auto">
          <div className="form-check">
            <label className="form-check-label">
              {
                behavior === 'multi-select' &&
                <input type="checkbox" className="form-check-input"
                       checked={choice.selected.value}
                       onChange={() => store.toggleChoice(index)}/>
              }
              {
                behavior === 'single-select' &&
                <input type="radio" className="form-check-input"
                       checked={choice.selected.value}
                       onChange={() => store.toggleChoice(index)}/>
              }
              Correct
            </label>
          </div>
        </div>
        <div className="col-auto">
          <button className="btn btn-danger"
                  onClick={() => store.removeChoice(index)}>
            Remove
          </button>
        </div>
      </div>
    );
  }

  if (!store.valid && store.behavior.value === 'single-select')
    yield (
      <div className="row" key="error">
        <div className="col">
          <div className="alert alert-danger">
            You must have one selected choice.<br/>
            You must have at least one unselected choice.<br/>
          </div>
        </div>
      </div>);

  if (!store.valid && store.behavior.value === 'multi-select')
    yield (
      <div className="row" key="error">
        <div className="col">
          <div className="alert alert-danger">
            You must have at least one choice.<br/>
          </div>
        </div>
      </div>);
}

@observer
export class X9McqCreate extends React.Component<{ store: AddContentStore }> {
  readonly store: McqEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new McqEditStore();
    this.disposers.add(this.store);
    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  render() {
    const store = this.store;

    return (Array.from(renderer(store)));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
